import { render, staticRenderFns } from "./App.vue?vue&type=template&id=354b3a85&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=354b3a85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../@vue-modules/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354b3a85",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../@vue-modules/vuetify/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VAlert,VApp,VCard})
